import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import {
  FormBuilder,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { ParentButtonComponent } from '../../../../shared/components/ui/parent-button/parent-button.component';
import { InputFieldComponent } from '../../../../shared/components/ui/input-field/input-field.component';

export type StepUpPasswordDialogData = {
  titleKey: string;
  bodyKey: string;
  confirmKey?: string;
};

@Component({
  selector: 'app-step-up-password-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    ReactiveFormsModule,
    TranslatePipe,
    ParentButtonComponent,
    InputFieldComponent,
  ],
  templateUrl: './step-up-password-dialog.component.html',
  styleUrl: './step-up-password-dialog.component.scss',
})
export class StepUpPasswordDialogComponent {
  #dialogRef = inject(MatDialogRef<StepUpPasswordDialogComponent, string | null>);
  #fb = inject(FormBuilder);
  readonly data = inject<StepUpPasswordDialogData>(MAT_DIALOG_DATA);

  readonly form = this.#fb.nonNullable.group({
    password: ['', [Validators.required]],
  });

  cancel(): void {
    this.#dialogRef.close(null);
  }

  confirm(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.#dialogRef.close(this.form.controls.password.value);
  }
}
